import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import {  message  } from 'antd';


import NumberFormat from 'react-number-format'


import { useTranslation } from 'react-i18next'

import './tan.css'
import {getLiushuiUsdt} from "../../api";
import {
    LeftOutlined 
  } from '@ant-design/icons';

const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const IndexUsdt = (props) => {
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [list,setList] = useState([])
    const [classesList,setClassesList]=useState([])
    const [page,setPage]=useState(1)


    const _getNewClassess = (e) =>{

         _getLiushuiUsdt(e)
    }


    const _getLiushuiUsdt = (c) =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getLiushuiUsdt({classes:c,page:page}).then(res=>{
            if(res.code === 0 ){

                if(res.data.classesList != null){
                    setClassesList(res.data.classesList)
                }


                    setList(res.data.list || [])


            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }





    useEffect(() => {
            window.scrollTo(0, 0)
            _getLiushuiUsdt(999)
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>
                    <Head/>
                    
                    <div className=' w-full min-h-screen  mt-16 '>
                        {/*  */}
                        <div
                            className="
                                 inset-0 z-50 w-full
                                flex items-center justify-center
                                bg-black/30
                                backdrop-blur-[14px]
                                backdrop-saturate-150
                                
                            "
                            >
                            <div
                                className="
                                relative
                                w-full max-w-[390px]
                                min-h-[520px]
                                px-5 py-6
                               
        
                                bg-black/80
        
                                border-0 border-[#4A5560]
        
                                shadow-[0_0_30px_rgba(0,0,0,.95),inset_0_0_30px_rgba(12,18,24,.8)]
        
                                [clip-path:polygon(9px_0,calc(100%-9px)_0,100%_9px,100%_calc(100%-9px),calc(100%-9px)_100%,9px_100%,0_calc(100%-9px),0_9px)]
                                "
                            >
                                {/* Close */}
                                
        
                                {/* 外层细线 */}
                                <div
                                className="
                                     inset-[6px]
                                    pointer-events-none
                                    
        
                                    [clip-path:polygon(14px_0,calc(100%-14px)_0,100%_14px,100%_calc(100%-14px),calc(100%-14px)_100%,14px_100%,0_calc(100%-14px),0_14px)]
                                "
                                />
        
                                
        
                                
        
                                {/* 左上角 */}
                                <div className="absolute left-[10px] top-[10px] w-[58px] h-[28px] border-l-2 border-t-2 border-[#894a02]" />
                                
        
                                {/* 右上角 */}
                                <div className="absolute right-[10px] top-[10px] w-[58px] h-[28px] border-r-2 border-t-2 border-[#894a02]" />
                                
        
                                {/* 左下角 */}
                                <div className="absolute left-[10px] bottom-[10px] w-[58px] h-[28px] border-l-2 border-b-2 border-[#894a02]" />
                                
        
                                {/* 右下角 */}
                                <div className="absolute right-[10px] bottom-[10px] w-[58px] h-[28px] border-r-2 border-b-2 border-[#894a02]" />
                            
        
                            
        
                                {/* 内部暗色纹理线 */}
                                <div
                                className="
                                    absolute inset-0
                                    opacity-25
                                    pointer-events-none
                                    bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,.035)_50%,transparent_100%)]
                                "
                                />
        
                                {/* 内容区域 */}
                                <div className="relative z-10">
                                {/* 这里放你的弹窗内容 */}
                                    <div className=' w-full  flex felx-row items-center '>
                                                        {/* <div className=' w-2 h-4 mr-2 rounded-3xl bg-text-act'></div> */}
                                                        {/* <img onClick={()=>window.history.back()} alt='rr' className='mr-1  ' src={require('../../assets/bg/game/back.png')} style={{"width":"30px"}}></img> */}
                                                            <div onClick={()=>window.history.back()} className=' text-base font-bold text-text-act mr-2 flex flex-row items-center'><LeftOutlined /></div>
                                                            <span className=' text-xs font-bold text-text-act'>USDT  {t("r.历史记录")}</span>
                                                        </div>
                            <div className=' h-px bg-slate-800 mt-2'></div>
        
                            <div className="w-full py-3 flex flex-row justify-items-start items-center flex-wrap  border-b border-border-b">
                                {
                                    classesList.length>0?
                                        classesList.map((item,index)=> {
                                            return (
                                                <span onClick={()=>_getNewClassess(item.Classes)} className=" inline-block px-2 py-1 rounded-xl bg-gray-800 text-[10px] text-defi-font2 mb-2 mr-2">{item.Name}</span>
                                            )
                                        }):null
                                }
        
                            </div>
        
                            {
                                list.length>0?
                                    list.map((item,index)=> {
                                        return (
                                            <div className="w-full flex flex-col  border-b border-border-b pb-3 pt-4">
                                                <div className='w-full flex flex-row items-center justify-between'>
                                                    <span className=" text-xs text-gray-200">{t("r.类型")}：{item.classname}</span>
                                                    {
                                                        item.value>0?(
                                                            <div className=" text-green-400">
                                                                <span className=" text-xs mr-1">+</span>
                                                                <span className=" text-xs mr-1">
                                                            <NumberFormat
                                                                thousandsGroupStyle="thousand"
                                                                value={item.value}
                                                                prefix=""
                                                                decimalSeparator="."
                                                                displayType="text"
                                                                type="text"
                                                                thousandSeparator={true}
                                                                allowNegative={false}
                                                                decimalScale={6} />
                                                        </span>
                                                                {/* <span className=" text-base">BNB</span> */}
                                                            </div>
                                                        ):(
                                                            <div className=" text-red-500">
                                                                <span className=" text-xs mr-1">-</span>
                                                                <span className=" text-xs mr-1">
                                                            <NumberFormat
                                                                thousandsGroupStyle="thousand"
                                                                value={item.value}
                                                                prefix=""
                                                                fixedDecimalScale
                                                                decimalSeparator="."
                                                                displayType="text"
                                                                type="text"
                                                                thousandSeparator={true}
                                                                allowNegative={false}
                                                                decimalScale={4} />
                                                        </span>
                                                                {/* <span className=" text-base">MEBA</span> */}
                                                            </div>
                                                        )
                                                    }
        
        
                                                </div>
                                                <div className='w-full mt-2 flex flex-row items-center justify-between text-gray-400'>
                                                    <span className=" text-xs">{t("r.备注")}：{item.memo}</span>
                                                    <span className=" text-xs mr-1">{item.add_time}</span>
                                                </div>
                                            </div>
                                        )
                                    }):(
                                        <div  className=' w-full  py-32 flex flex-row items-center justify-center text-gray-400 text-xs'>
                                            No data
                                        </div>
                                    )
                            }
                                {/*  */}
                                </div>
                            </div>
                            </div>
        
                        {/* people */}
                       
        
        
        
                    </div>
                    <div className=' w-full h-8'></div>
                   
        
        
                </>
    );
}

export default connect(mapStateToProps)(IndexUsdt);
